import { useState } from "react";

type PrimeDetailsActionButtonProps = {
  label: string;
  icon: string;
  onClick: () => void | Promise<void>;
  loading?: boolean;
  skipBusy?: boolean;
  disabled?: boolean;
  tone?: "default" | "danger" | "warning";
};

const toneClasses = {
  default: "border-border-button-secondary bg-bg-button-secondary",
  danger: "border-transparent bg-bg-status-red",
  warning: "border-transparent bg-bg-status-yellow",
};

const PrimeDetailsActionButton = ({
  label,
  icon,
  onClick,
  loading = false,
  skipBusy = false,
  disabled = false,
  tone = "default",
}: PrimeDetailsActionButtonProps) => {
  const [isBusy, setIsBusy] = useState(false);
  const isLoading = loading || isBusy;
  const isDisabled = disabled || isLoading;

  const handleClick = async () => {
    if (isDisabled) return;
    if (!skipBusy) setIsBusy(true);
    try {
      await onClick();
    } finally {
      if (!skipBusy) setIsBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isDisabled}
      className={`inline-flex items-center gap-1 h-7 px-2.5 rounded-md border text-[11px] font-medium tracking-tight text-text-base hover:opacity-80 disabled:opacity-50 disabled:cursor-not-allowed transition-opacity cursor-pointer ${toneClasses[tone]}`}
    >
      <span
        className={`material-symbols-outlined text-[14px] leading-none ${
          isLoading ? "animate-spin" : ""
        }`}
      >
        {isLoading ? "progress_activity" : icon}
      </span>
      {label}
    </button>
  );
};

export default PrimeDetailsActionButton;
